import React from "react";
import { Button } from "semantic-ui-react";
import { useAuth } from "../../../context/auth-context";

const LogOutLink = () => {
  const { logout } = useAuth();
  let style = {
    background: "transparent",
    padding: "0",
    color: "#c60000",
    textDecoration: "underline",
  };

  return (
    <span>
      Your session has expired, please{" "}
      <Button style={style} onClick={logout}>
        log out
      </Button>{" "}
      and log back in.
    </span>
  );
};
export { LogOutLink };
